<template>
    <component
        :is="link || routerLink ? (routerLink && link ? 'router-link':'a') : 'button'"
        :to="routerLink && link ? link : false"
        :type="!link ? type : false"
        :href="link && !routerLink ? link : false"
        class="button relative border text-xs font-plus-sans-bold font-extrabold transition-colors ease-in-out duration-500 w-full md:w-auto text-center focus:outline-none px-3 py-2 tracking-widest-xl uppercase"
        :class="[buttonClasses[buttonClass],iconPosition === 'right' ? 'icon-button-right' : 'icon-button-left',{ 'icon-button': icon, 'no-underline pointer align-center border-box': link,   'opacity-50 cursor-not-allowed pointer-events-none': disabled || loading}]"
        :disabled="disabled || loading"
    >
        <i v-if="icon && iconPosition == 'left'" :class="'zmdi-' + icon" class="zmdi text-lg mr-1 leading-none transform translate-y-0.5"></i>
        <span :class="{'opacity-0': loading}">
            <slot>
                Button
            </slot>
        </span>
            <svg v-if="loading" class="absolute left-1/2 top-1/2 animate-spin -ml-2.5 -mt-2.5 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>

        <i v-if="icon && iconPosition == 'right'" :class="'zmdi-' + icon" class="zmdi text-lg ml-1 leading-none transform translate-y-0.5"></i>
    </component>
</template>

<script>

    export default {

        data() {
            return {
                buttonClasses: {
                    normal: 'bg-neutral-default border-neutral-default hover:bg-primary-default hover:border-primary-default text-white',
                    invert: 'bg-transparent border-neutral-default hover:border-primary-default text-neutral-default hover:text-primary-default',
                    invert_white: 'bg-white border-neutral-default hover:border-primary-default text-neutral-default hover:text-primary-default',
                    white: 'bg-white border-white hover:border-white text-neutral-default hover:text-primary-default',
                }
            }
        },
        props: {
            type: {
                type: String,
                required: false,
                default: 'button'
            },
            buttonClass: {
                type: String,
                required: false,
                default: 'normal'
            },
            routerLink: {
                type: Boolean,
                required: false,
                default: false
            },
            link: {
                type: String,
                required: false,
                default: null
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            loading: {
                type: Boolean,
                required: false,
                default: false
            },
            icon: {
                type: String,
                required: false,
                default: ''
            },
            iconPosition: {
                type: String,
                required: false,
                default: 'left'
            },
            buttonSize: {
                type: String,
                required: false,
                default: 'regular'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .disabled {
        background-color: gray
    }
</style>

<style lang="scss">
    .button-full {
        min-width: 250px;
    }
</style>
